<template>
  <div class="navigation">
    <div class="main-panel">
      <div class="navigation__links">
        <IconButton
          v-for="item in navigation.items"
          :key="item.slug"
          form="transparent"
          :class="getLinkClass(item)"
          width="full"
          :icon="hasChildLinks(item) ? 'chevron-right' : ''"
          icon-position="right"
          text-align="left"
          :tag="hasChildLinks(item) ? 'button' : 'a'"
          :href="item.url"
          @click="
            handleNavigationClick(item);
            hasChildLinks(item) && openMegaNav(item.slug);
          "
        >
          {{ item.title }}
          <div class="badges">
            <Badge
              v-for="(badge, index) in item.badges"
              :key="index"
              size="small"
              :theme="badge.theme"
            >
              {{ badge.text }}
            </Badge>
          </div>
          <span class="sub-text">
            {{ subText(item.text) }}
          </span>
        </IconButton>
      </div>

      <NavigationBanner
        v-if="navigation.banner"
        :images="navigation.banner.images"
        :text="navigation.banner.text"
        :url="navigation.banner.url"
      />

      <div class="sub-navigation">
        <Button
          form="underline-invert"
          theme="primary"
          tag="a"
          href="/pages/returns"
          class="sub-navigation__link"
        >
          Returns
        </Button>
        <Button
          form="underline-invert"
          theme="primary"
          tag="a"
          href="/pages/help"
          class="sub-navigation__link"
        >
          Need Help?
        </Button>
        <Currency
          :options="dropdownoptions"
          :selected="currencyCode"
          title="Currency"
          class="currency-dropdown"
          @changed="handleCurrencyChange"
        />
      </div>
    </div>
    <ChildNavigationPanel class="sub-panel" />
  </div>
</template>

<script>
import Button from "@/components/ButtonV2.vue";
import IconButton from "@/components/IconButton.vue";
import ChildNavigationPanel from "@/components/navigation/ChildNavigationPanel.vue";
import DropDown from "@/components/DropDown.vue";
import Badge from "@/components/BadgeV2.vue";
import { mapActions, mapGetters, mapState } from "vuex";
// import navigationContent from "@/content/navigation.json";
import { signUpBonus } from "@/config";
import NavigationBanner from "@/components/navigation/NavigationBanner.vue";
import { navigationClickEvent } from "@/helpers/events";

export default {
  name: "Navigation",
  components: {
    Currency: DropDown,
    Button,
    IconButton,
    ChildNavigationPanel,
    Badge,
    NavigationBanner,
  },
  data() {
    return {
      dropdownoptions: [
        {
          value: "gbp",
          label: "GBP (£)",
        },
        {
          value: "eur",
          label: "EUR (€)",
        },
        {
          value: "usd",
          label: "USD ($)",
        },
        {
          value: "aud",
          label: "AUD ($)",
        },
      ],
    };
  },
  computed: {
    ...mapState("app", ["navVersion"]),
    ...mapGetters("app", ["currencyCode"]),
    navigation() {
      try {
        return require(`@/content/navigationV${this.navVersion}.json`);
      } catch (e) {
        console.error(e);
        return require(`@/content/navigationV2.json`);
      }
    },
  },
  methods: {
    ...mapActions("app", ["changeCurrency", "openMegaNav"]),
    handleCurrencyChange(value) {
      this.changeCurrency(value);
    },
    hasChildLinks(item) {
      if (item.mega?.columns.length > 0) {
        return true;
      }
      return false;
    },
    subText(text) {
      if (!text) {
        return null;
      }

      return text.replace("{{bonus}}", this.bonus);
    },
    bonus() {
      if (!this.currencyCode) {
        return null;
      }
      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
    getLinkClass(item) {
      const baseClass = "navigation__link";
      if (item.modifier) {
        return `${baseClass} navigation__link--${item.modifier}`;
      }
      return baseClass;
    },
    handleNavigationClick(item) {
      console.log("handleNavigationClick", item);
      navigationClickEvent({
        title: item.title,
        url: item.url,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";
@import "@/assets/css/components/navigation";

.navigation {
  position: relative;
  display: flex;
  overflow: hidden;

  .main-panel,
  .sub-panel {
    flex: 1 0 100%;
  }

  &__links {
    padding: 0 24px;
  }

  &__link {
    padding: 16px 0;
    border-radius: 0;
    border-top: 1px solid $color-grey-light;

    &--highlight {
      color: $color-red;
    }

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:last-child {
      border-bottom: 1px solid $color-grey-light;
    }

    .badges {
      position: relative;
      top: -5px;
    }

    .sub-text {
      @include utility-label(12px);
      color: $color-grey-dark;
      margin-left: 8px;
    }
  }
}

.sub-navigation {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px 24px 24px;
}

.currency-dropdown {
  box-shadow: none;

  :deep() {
    .button {
      padding: 0;

      .text {
        @include utility-label(14px);
      }
    }

    .dropdown__panel {
      margin-top: 10px;
      position: static;
      box-shadow: none;
    }

    .dropdown__item-button {
      padding-left: 0;
      padding-right: 0;

      .label {
        @include utility-label(14px);
      }
    }
  }
}
</style>
